<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li><a [routerLink]="['/']">Home</a></li>
      <li>Artikelvorlagen</li>
    </ul>
  </div>
  <a [routerLink]="['/', 'artikelvorlagen', 'neu']" class="bm-btn"> <i class="fa fa-plus"></i> Neue Artikelvorlagen </a>
  <div class="bm-join">
    <input class="bm-join-item bm-input" type="text" (input)="quicksearchChanged($event)" placeholder="Schnellfilter" />
    <a class="bm-join-item bm-btn bm-btn-primary bm-btn-square" [cdkMenuTriggerFor]="tplMenu">
      <i class="fa fa-ellipsis-v"></i>
    </a>
    <ng-template #tplMenu>
      <ul
        cdkMenu
        class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
      >
        <li class="bm-divider m-0 p-0 h-0 bm-divider-secondary"></li>
        <li>
          <a (click)="saveState()">
            <i class="fa fa-save"></i>
            Config speichern
          </a>
        </li>
        <li>
          <a (click)="deleteState()">
            <i class="fa fa-ban"></i>
            Config löschen
          </a>
        </li>
      </ul>
    </ng-template>
  </div>
</div>

<div class="page-content page-frame">
  <ag-grid-angular
    class="ag-theme-quartz h-full"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [rowData]="articleTemplates"
    [rowSelection]="rowSelection"
    [initialState]="initialState"
    [paginationPageSize]="paginationPageSize"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    (gridReady)="onGridReady($event)"
  />
</div>
